import type { HilPresentationReplyEnvelope } from '@bizfirst/hil-types';
import type { IHilSubmitClient, HilSubmitResult } from './IHilSubmitClient';
import { parseHilSubmitError } from './parseHilSubmitError';

export class FetchHilSubmitClient implements IHilSubmitClient {
  async post(url: string, payload: HilPresentationReplyEnvelope): Promise<HilSubmitResult> {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        return { ok: false, statusCode: response.status, error: await parseHilSubmitError(response) };
      }
      return { ok: true, statusCode: response.status };
    } catch (err) {
      return { ok: false, error: err instanceof Error ? err.message : String(err) };
    }
  }
}
